import { Injectable } from '@angular/core';
import { GlobalConstants } from "src/app/constants";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import {
  UserMasterAdapter,
  UserMaster
} from "../Model/user-master";
import { map } from "rxjs/operators";
import * as moment from "moment";

@Injectable({
  providedIn: 'root'
})
export class UserMasterService {
  private baseURL =
    GlobalConstants.BASE_API_URL + ":" + GlobalConstants.BASE_API_URL_PORT;
  private API_NAME = "SYUserMaster";

  constructor(
    private httpClient: HttpClient,
    private adapter: UserMasterAdapter
  ) {}

  getAll(): Observable<UserMaster[]> {
    const url = `${this.baseURL}/${this.API_NAME}/api/get/all`;
    return this.httpClient.get(url).pipe(
      // Adapt each item in the raw data array
      map((data: any[]) => data["data"].map(item => this.adapter.adapt(item)))
    );
  }

  checkForDuplicate(
    userID,
    id
  ): Observable<UserMaster[]> {
    // If id is <> null, then it is an update and need to make sure
    // not checking for a duplicate on it's on record ID, else
    // check without ID on a create
    if (id != null) {
      const url = `${this.baseURL}/${this.API_NAME}/api/check/duplicate`;
      const params = new HttpParams()
        .set("userID", userID)
        .set("id", id);
      return this.httpClient.get(url, { params }).pipe(
        // Adapt each item in the raw data array
        map((data: any[]) => data["data"].map(item => this.adapter.adapt(item)))
      );
    } else {
      // Creation duplicate check, since no ID.  No need to check by ID
      const url = `${this.baseURL}/${
        this.API_NAME
      }/api/get/byUserID`;
      const params = new HttpParams()
        .set("userID", userID);
      return this.httpClient.get(url, { params }).pipe(
        // Adapt each item in the raw data array
        map((data: any[]) => data["data"].map(item => this.adapter.adapt(item)))
      );
    }
  }

  update(formData, id) {
    // Format lastUpdated to IBM i standards
    formData.lastUpdated = moment().format("YYYY-MM-DD-HH.mm.ss");

        // Format dates from mydatepicker
        if (formData.birthday) {
          formData.birthday =
            <string>formData.birthday.date.year +
            "-" +
            String(formData.birthday.date.month).padStart(2, "0") +
            "-" +
            String(formData.birthday.date.day).padStart(2, "0");
        }
        if (formData.anniversary) {
          formData.anniversary =
            <string>formData.anniversary.date.year +
            "-" +
            String(formData.anniversary.date.month).padStart(2, "0") +
            "-" +
            String(formData.anniversary.date.day).padStart(2, "0");
        }
        if (formData.hireDate) {
          formData.hireDate =
            <string>formData.hireDate.date.year +
            "-" +
            String(formData.hireDate.date.month).padStart(2, "0") +
            "-" +
            String(formData.hireDate.date.day).padStart(2, "0");
        }

    // Add database ID to the JSON object for update service
    formData.id = id;
    formData.changeID = localStorage.getItem("user");
    const url = `${this.baseURL}/${this.API_NAME}/api/update`;
    return this.httpClient.post(url, formData);
  }

  delete(id) {
    const url = `${this.baseURL}/${this.API_NAME}/api/delete`;
    return this.httpClient.post(url, { id: id });
  }

  create(formData) {
        // Format dates from mydatepicker
        if (formData.birthday) {
          formData.birthday =
            <string>formData.birthday.date.year +
            "-" +
            String(formData.birthday.date.month).padStart(2, "0") +
            "-" +
            String(formData.birthday.date.day).padStart(2, "0");
        }
        if (formData.anniversary) {
          formData.anniversary =
            <string>formData.anniversary.date.year +
            "-" +
            String(formData.anniversary.date.month).padStart(2, "0") +
            "-" +
            String(formData.anniversary.date.day).padStart(2, "0");
        }
        if (formData.hireDate) {
          formData.hireDate =
            <string>formData.hireDate.date.year +
            "-" +
            String(formData.hireDate.date.month).padStart(2, "0") +
            "-" +
            String(formData.hireDate.date.day).padStart(2, "0");
        }

    formData.changeID = localStorage.getItem("user");

    const url = `${this.baseURL}/${this.API_NAME}/api/create`;
    return this.httpClient.post(url, formData);
  }
}
